import { render, staticRenderFns } from "./IikoCardsSettings.vue?vue&type=template&id=7c0a7705&scoped=true"
import script from "./IikoCardsSettings.vue?vue&type=script&lang=js"
export * from "./IikoCardsSettings.vue?vue&type=script&lang=js"
import style0 from "./IikoCardsSettings.vue?vue&type=style&index=0&id=7c0a7705&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0a7705",
  null
  
)

export default component.exports